import { ApplicationModule, Injectable } from '@angular/core';
import { CloudFunctionsService } from './cloud-functions.service';
import { CurrentInfoService } from './current-info.service';
import { WorkWeekService } from './work-week.service';
import { AppConfigService } from './app-config.service';
import { ItemMenuService } from './item-menu.service';
import { Router } from '@angular/router';
import { CustomerService } from './customer.service';
import { TranslateService } from '@ngx-translate/core';
import { LocaleService } from './locale.service';
import { AnalyticsService as AnalyticsService } from './analytics.service';
import { CouponsService } from './coupons.service';

@Injectable({
  providedIn: 'root',
})
export class InitializationService {
  constructor(
    private cloudfunctionservice: CloudFunctionsService,
    private currentinfoservice: CurrentInfoService,
    private workweekservice: WorkWeekService,
    private appconfigservice: AppConfigService,
    private itemmenuservice: ItemMenuService,
    private router: Router,
    private customerservice: CustomerService,
    private pixelservice: AnalyticsService,
    private couponsservice: CouponsService
  ) {}

  _appName: string = '';
  _initialized: boolean = false;

  public async Initialize(appName: string): Promise<boolean> {
    if (appName === null || appName === undefined || appName === '')
      throw new Error('appName not provided.');

    if (this._initialized === true) return true;

    var customerID = this.customerservice.getCustomerID();

    var initializationPack =
      await this.cloudfunctionservice.getInitializationPack(
        appName,
        customerID
      );

    if (initializationPack != null && initializationPack != undefined) {
      this.currentinfoservice.Initialize(initializationPack.CurrentInfo);
      this.workweekservice.Initialize(initializationPack.WorkWeek);
      this.appconfigservice.initialize(initializationPack.AppConfig);
      this.itemmenuservice.initialize(initializationPack.ItemMenu);
      this.customerservice.Initialize(initializationPack.CustomerProfile);
      this.couponsservice.initialize(initializationPack.Coupons);
    }

    this.pixelservice.initialize();

    this._appName = appName;
    this._initialized = true;

    return true;
  }

  public setReload() {
    this._initialized = false;
  }

  public reloadApp(appname: string) {
    this.router.navigateByUrl('/' + appname);
  }

  public checkApp(appname: string) {
    return appname === this._appName;
  }
}
